export function buildUrl(baseUrl: string, params:  Record<string, string|number>) {
    if (!params) {
      return baseUrl;
    }
  
    const url = baseUrl.replace(
      /{([^{}]*)}/g,
      (match, param) => params[param] as string
    );
  
    return url;
  }